import React, { useState, useEffect } from 'react';

// Même base d'URL que le client axios (api.ts) : relative (/api) en production.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export default function ErreurReseau() {
  const [horsLigne, setHorsLigne] = useState(!navigator.onLine);
  const [serveurIndispo, setServeurIndispo] = useState(false);

  useEffect(() => {
    const handleOnline = () => setHorsLigne(false);
    const handleOffline = () => setHorsLigne(true);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Vérifier la disponibilité du serveur toutes les 30 secondes
    const verifierServeur = async () => {
      try {
        const res = await fetch(API_URL, {
          method: 'GET',
          signal: AbortSignal.timeout(5000),
        });
        // Le serveur répond (même un 404 signifie qu'il est en ligne)
        setServeurIndispo(false);
      } catch (e) {
        // Erreur réseau réelle = serveur injoignable
        if (navigator.onLine) {
          setServeurIndispo(true);
        }
      }
    };
    verifierServeur();
    const interval = setInterval(verifierServeur, 30000);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(interval);
    };
  }, []);

  if (!horsLigne && !serveurIndispo) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0,
      zIndex: 9999,
      background: horsLigne ? '#A32D2D' : '#854F0B',
      color: '#fff',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 13,
      fontWeight: 500,
      boxShadow: '0 2px 8px rgba(0,0,0,.2)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ fontSize: 18 }}>{horsLigne ? '📡' : '⚠️'}</span>
        <div>
          <div>
            {horsLigne
              ? 'Connexion internet perdue'
              : 'Serveur NexaCom indisponible'}
          </div>
          <div style={{ fontSize: 11, opacity: .8, marginTop: 2 }}>
            {horsLigne
              ? 'Vérifiez votre connexion réseau ou WiFi'
              : 'Le serveur backend ne répond pas — vérifiez qu\'il est démarré'}
          </div>
        </div>
      </div>
      <button
        onClick={() => window.location.reload()}
        style={{
          background: 'rgba(255,255,255,.2)',
          border: '1px solid rgba(255,255,255,.4)',
          color: '#fff',
          padding: '6px 14px',
          borderRadius: 6,
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 600,
        }}>
        🔄 Réessayer
      </button>
    </div>
  );
}